import React, {useState, useEffect , useRef} from "react";
import Header from 'layouts/Header'
import Footer from 'layouts/Footer'
import Logo from 'layouts/logo';
import ScrollPageTop from 'components/ui/ScrollPageTop'
import {EyeOff, Eye, Loading} from "components/custom-icons";
import Button from 'components/ui/Button.tsx'
import Input from 'components/ui/input.jsx'

import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
 } from 'react-hook-form';

import axios from 'axios';  
import { yupResolver } from '@hookform/resolvers/yup';
import {API_ENDPOINT,toast_anim , toast_anim_error} from 'components/config/Common'
import {useAuth} from 'contexts/provider/AuthProvider'
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {Links} from 'routes/PathLink'
import ModalView from '_utils/ModalView'
import {deviceDetect} from "react-device-detect"
import { produce } from 'immer';
import { useDoctorReg } from "contexts/doctorregistration/doctor-reg";
import SocialLogin from "components/auth/SocialLogin";
import OtpInput from "react-otp-input";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
const SignupSchema = Yup.object().shape({
	 email: Yup.string()
      .required('You must need to provide your email address.')
      .email('Invalid email.'),
});

const defaultValues = {  
   email: '',
 };

const SignupwithEmail = (props) => {
   const [show, setshow] = useState(false);
   const [loading, setLoading] = useState(false);
   const {form,setForm} = useDoctorReg();

   const { login } = useAuth();
   let navigate = useNavigate();
   const [isOpen, setIsOpen] = useState(false)
   const [otp, setotp] = useState('');
  const [final, setfinal] = useState('');
  const [whereto, setWhereto] = useState('');
  const [email, setEmail] = useState(false);
  const [userData,setUserData] = useState([]);
      const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(SignupSchema),
      shouldFocusError:false,
   });
const refphone = useRef(null);
   useEffect(() => {
      props.setActivestepfun(2);
      if(localStorage.getItem('access_token')){
         return navigate("/", { replace: true });
      }
   })

   const handleView = () => {
		setIsOpen(true)
	}

     const ValidateOtp = () =>{
      console.log("OTP VALE",otp);
      if(final?.otp ==  otp){
        // alert("OTP MATCHED");
        let values = {
         email:email
        };
         axios
         .post(API_ENDPOINT+'/check_expert_exist', values)
         .then((response) => {
            console.log("RESPONSE",response.data);
            if(response.data?.status == 1){
              // alert("DOCTOR EXIST");
              toast_anim_error("You're alreay register with us , please login with details.");
            }else{
               //alert("DOCTOR Not EXIST");
               props.setActivestepfun(2);
            }
         });
      }else{
         toast_anim_error("OTP INVALID");
          //alert("OTP INVALID");
      }
   }
   const closeModal = () => {
      setIsOpen(false)      
   }

    const loginsubmit = async (values) => {
       //props.setActivestepfun(2);
       setLoading(true);
        let input ={
                  email:values?.email,
                  from:'email',
                } ;
       values = input;
       setForm(
          produce((formState) => {
            formState.steps.main = {
              values,
              valid: true,
              dirty: false,
            };
          }));
       axios
         .post(API_ENDPOINT+'/check_expert_exist', values)
         .then((response) => {
            console.log("RESPONSE",response.data);

            if(response.data?.status == 1){
              // alert("DOCTOR EXIST");
               setLoading(false);
               toast_anim_error("You're alreay register with us , please login with details.");
              // props.setActivestepfun(2);
            }else{

                console.log("Value from form ",values)

                  setForm(
                   produce((formState) => {
                     formState.steps.main = {
                       values,
                       valid: true,
                       dirty: false,
                     };
                   }));
                   console.log("form Data ",form);
                
                   setEmail(values?.email);
                   axios
                  .post(API_ENDPOINT+'/send_email_otp', values)
                  .then((response) => {
                     console.log("RESPONSE",response.data);
                        
                     if(response.data?.status == 1){
                        //alert("Otp sent");
                        toast_anim("Otp sent on your email");
                        setshow(true);
                        setfinal(response.data?.data);
                        setLoading(false);
                       // props.setActivestepfun(2);
                     }else{
                         toast_anim_error("Error sending otp");
                         setLoading(false);
                        //alert("Error sending otp ");
                        //props.setActivestepfun(2);
                     }
                    //setPost(response.data);
                  });

               //alert("DOCTOR Not EXIST");
               //props.setActivestepfun(2);
            }

         });
       return false;
   }

   const setOtp = (val) =>{
      console.log("OPTBSADASD ",val)
      setotp(val);
   }
   return( <div className="flex justify-center">
            <div className="flex h-full  w-screen flex-col justify-center bg-light  px-5 md:h-auto md:min-h-0 md:max-w-[480px] md:rounded-xl my-5">
                  <>
                  {/* <div className="flex justify-center">
                  <h1 className="text-xl font-black text-accent">Login</h1>
                  </div> */}      
                  <form onSubmit={handleSubmit(loginsubmit)}>  
                  {/*<p className="mt-1 mb-8 text-center text-sm text-body  md:text-base">
                     Sign in with your Email and OTP
                  </p>*/}
                     <div className="mb-5">
                          <Input                
                              label={`Email`}
                              {...register('email')}
                              variant="outline"
                              className="mb-5"
                              type="email"
                              error={errors.email?.message}
                              required
                           />
                     </div>
                     <div className="mt-8 flex justify-center">
                        {
                        !loading
                        ?
                        <Button className="w-full" >Send OTP</Button>
                        :
                        <Loading className="w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-assent-600" />
                        }
                     </div>
               </form>
               
               </>
              
            </div>
         </div>)
}

export default SignupwithEmail